// missing some exception sites
const PageExceptions = {
  ksb: [/ksb/],
  secom: [/secom/],
  secombroker: [/secombroker/],
  secomclaims: [/secomclaims/],
  secommotorclaims: [/secommotorclaims/],
  sebreeders: [/sebreeders/],
  seanimal: [/seanimal/],
  dkcom: [/dkcom/],
  dkkvalitet: [/dkkvalitet/],
  dksalessupport: [/dksalessupport/],
  dkpriv: [/dkriv/],
  dkprivwebshop: [/dkprivwebshop/]
}
const HostExceptions = {
  fiwebshop: [/webshop.if.fi/, /webshopbasketfi.if.fi/],
}

// matchToUrls :: list => string => boolean
const matchToUrls = expressions => url => expressions
  .map(exp => exp.test(url))
  .reduce((a, b) => a || b);

// getPageExceptionTranslation :: client, dict => string
export const getPageExceptionTranslation = (client, translations) => {
  for (let key of Object.keys(PageExceptions)) {
    if (matchToUrls(PageExceptions[key])(client.myfullpath)) {
      return translations[key] || null;
    }
  }
  for (let key of Object.keys(HostExceptions)) {
    if (matchToUrls(HostExceptions[key])(window.location.hostname)) {
      return translations[key] || null;
    }
  }
  return null;
}

// is<siteException> :: url => boolean
export const [
  isDanishPrivate,
  isDanishPrivateWebshop
] = [
  PageExceptions.dkpriv,
  PageExceptions.dkprivwebshop
].map(matchToUrls)

